/*
 * El tema del panel: claro, oscuro, o el que diga el sistema.
 *
 * "Sistema" es el valor por defecto y no es lo mismo que "claro": significa
 * no tener opinion y seguir al sistema operativo, de modo que quien tenga el
 * portatil en oscuro al anochecer ve el panel cambiar con el. Quien elige
 * claro u oscuro a mano se queda ahi pase lo que pase fuera.
 *
 * Tecnicamente son tres estados y solo dos valores de `data-theme`: sin
 * atributo manda la media query del navegador, que es justo el comportamiento
 * de "sistema". Por eso elegir sistema BORRA el atributo en vez de escribir
 * nada.
 *
 * Las pantallas de acceso no pasan por aqui: van siempre en claro, lo decide
 * App.tsx. Ver tambien public/inicio.js, que aplica esto mismo antes del
 * primer fotograma para que no haya parpadeo.
 */

export type Tema = 'sistema' | 'claro' | 'oscuro';

/** Compartida con public/inicio.js, que lee esta misma clave. */
export const CLAVE_TEMA = 'apuntaqr:tema';

export const TEMAS: readonly { id: Tema; nombre: string }[] = [
  { id: 'sistema', nombre: 'Sistema' },
  { id: 'claro', nombre: 'Claro' },
  { id: 'oscuro', nombre: 'Oscuro' },
];

function esTema(valor: unknown): valor is Tema {
  return valor === 'sistema' || valor === 'claro' || valor === 'oscuro';
}

/**
 * Lo que el usuario eligio la ultima vez.
 *
 * En ventana privada o con el almacenamiento bloqueado, leer lanza. Ahi se
 * responde "sistema", que es el valor por defecto y nunca deja el panel en un
 * estado raro.
 */
export function temaGuardado(): Tema {
  try {
    const guardado = localStorage.getItem(CLAVE_TEMA);
    return esTema(guardado) ? guardado : 'sistema';
  } catch {
    return 'sistema';
  }
}

export function guardarTema(tema: Tema): void {
  try {
    if (tema === 'sistema') localStorage.removeItem(CLAVE_TEMA);
    else localStorage.setItem(CLAVE_TEMA, tema);
  } catch {
    // Sin almacenamiento la eleccion dura lo que la pestania. Es una molestia,
    // no un fallo: el panel se ve igual de bien.
  }
}

/** Escribe la eleccion en la raiz del documento. */
export function aplicarTema(tema: Tema): void {
  const raiz = document.documentElement;
  if (tema === 'sistema') raiz.removeAttribute('data-theme');
  else raiz.setAttribute('data-theme', tema === 'oscuro' ? 'dark' : 'light');
}
